import React, { useEffect } from 'react';

import { Page } from '@components';
import { Col, Row } from 'antd';
import { Title } from '@styles/components/text';
import { OrdersBody } from './components/orders-body';
import { useDispatch } from 'react-redux';
import { clearStateCampaign } from '@redux/slices/campaign';
import { translate } from '@components/i18n';

export const ScheduledOrders: React.FC = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(clearStateCampaign());
    }, []);

    return (
        <Page
            title={translate('pages.scheduledOrders')}
            greyBackground
            withPadding
        >
            <Row>
                <Col span={1} />
                <Col span={22}>
                    <Row>
                        <Title marginTop={20} level={3}>
                            {translate('titlePages.scheduledOrders')}
                        </Title>
                    </Row>
                    <OrdersBody />
                </Col>
                <Col span={1} />
            </Row>
        </Page>
    );
};
